import request from '@/utils/request'
import { v2Host } from '@/config/host'
import _ from 'lodash'
import { cookRequestParams } from '@/common/request'

const cookTaskParams = (params) => {
  if (_.isArray(params.time)) {
    /* eslint-disable camelcase */
    const [begin_time, end_time] = params.time
    params.begin_time = begin_time
    params.end_time = end_time
    /* eslint-enable camelcase */
    params = _.omit(params, ['time'])
  }
  if (_.isArray(params.app_cat_ids)) {
    params.app_cat_ids = params.app_cat_ids[params.app_cat_ids.length - 1]
  }
  return params
}

export function fetchTaskList(params) {
  return request({
    url: `${v2Host}/qa/task/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * http://playable.dev.com:8067/?doc=qa/task.go#%2fqa%2ftask%2flist-all
 * @param {{}} params
 */
export function fetchTaskAllList(params) {
  return request({
    url: `${v2Host}/qa/task/list-all`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * http://playable.dev.com/doc/?route=Qa/Task#makeDebugUrlAction
 * @param {{id: Number}} 任务id
 * @return {Promise<any>}
 */
export function makeDebugUrl(params) {
  const id = params.id
  params = _.omit(params, ['id'])
  return request({
    url: `${v2Host}/qa/task/make-debug-url?id=${id}`,
    method: 'post',
    params: params,
  })
}

export function updateMyTestZip(params) {
  const id = params.id
  params = _.omit(params, ['id'])
  return request({
    url: `${v2Host}/qa/task/update-zip?id=${id}`,
    method: 'post',
    data: params,
    withoutError: 1,
  })
}

export function updateMyTestPerson(params) {
  const id = params.id
  params = _.omit(params, ['id'])
  return request({
    url: `${v2Host}/qa/task/update?id=${id}`,
    method: 'post',
    data: params,
  })
}

export function passAdvAudit(params) {
  return request({
    url: `${v2Host}/qa/task/adv-audit`,
    method: 'post',
    data: params,
  })
}

export function publishTask(params) {
  const id = params.id
  params = _.omit(params, ['id'])
  return request({
    url: `${v2Host}/qa/task/publish?id=${id}`,
    method: 'post',
    data: params,
    withoutError: 1,
  })
}

export function changeAudit(params) {
  const id = params.id
  params = _.omit(params, ['id'])
  return request({
    url: `${v2Host}/qa/task/adv-audit-app?id=${id}`,
    method: 'post',
    data: params,
  })
}

export function cancelTestTask(params) {
  const id = params.id
  params = _.omit(params, ['id'])
  return request({
    url: `${v2Host}/qa/task/cancel?id=${id}`,
    method: 'post',
    data: params,
  })
}

export function submitToTestTask(params) {
  const id = params.id
  params = _.omit(params, ['id'])
  return request({
    url: `${v2Host}/qa/task/submit-to-test?id=${id}`,
    method: 'post',
    data: params,
    withoutError: 1,
  })
}

export function changeTaskStatus(params) {
  const id = params.id
  params = _.omit(params, ['id'])
  return request({
    url: `${v2Host}/qa/task/change?id=${id}`,
    method: 'post',
    data: params,
  })
}

/**
 * http://playable.dev.com/doc/?route=Qa/Task#rollbackAction
 * @param {Object} params
 * @param {Number/String} params.id 任务ID
 * @param {String} params.reason 撤回原因
 */
export function rollbackTask(params) {
  const id = params.id
  params = _.omit(params, ['id'])
  return request({
    url: `${v2Host}/qa/task/rollback?id=${id}`,
    method: 'post',
    data: params,
  })
}

export function fetchTaskDetail(params) {
  return request({
    url: `${v2Host}/qa/task/detail`,
    method: 'get',
    params: cookTaskParams(params),
  })
}

/**
 * http://playable.dev.com:8067/?doc=qa/task.go#%2fqa%2ftask%2fadjust-owner
 * @param {{type: number, ids: string, owner_id: number|string}} data
 */
export function adjustTaskOwner(data) {
  return request({
    url: `${v2Host}/qa/task/adjust-owner`,
    method: 'post',
    data: cookRequestParams(data),
  })
}

// 隐藏&展示猜你喜欢 http://localhost:8067/?doc=qa/task.go#%2fqa%2ftask%2fhide-show-guess-like
export function hideShowGuessLike(params) {
  const id = params.id
  params = _.omit(params, ['id'])
  return request({
    url: `${v2Host}/qa/task/hide-show-guess-like?id=${id}`,
    method: 'post',
    data: params,
  })
}
